<div class="tw-flex tw-flex-col tw-gap-4 tw-pb-2">
  <!-- Top card: symbol, price, date, timezone -->
  <div class="tw-rounded-xl tw-bg-dt-surface-card tw-p-4 tw-shadow-elevation-card">
    <div class="tw-flex tw-items-start tw-justify-between tw-mb-4">
      <span class="tw-text-3xl tw-font-bold tw-text-color-text-default">{{ price.base }}</span>
      <div class="tw-flex tw-items-baseline tw-gap-1">
        <span class="tw-text-xl tw-font-semibold tw-text-color-text-default">{{
          price.rate | number: "1.0-2"
        }}</span>
        <span class="tw-text-sm tw-font-medium tw-text-color-text-tertiary tw-uppercase">{{
          price.symbol
        }}</span>
      </div>
    </div>
    <div class="tw-grid tw-grid-cols-2 tw-gap-3">
      <div class="tw-flex tw-flex-col tw-gap-1">
        <span
          class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-text-color-text-tertiary"
        >
          {{ "asOnDate" | i18n }}
        </span>
        <span class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
          price.date.date
        }}</span>
      </div>
      @if (price.date.timeZone) {
        <div class="tw-flex tw-flex-col tw-gap-1 tw-text-right">
          <span
            class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-text-color-text-tertiary"
          >
            TIME ZONE
          </span>
          <span class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
            price.date.timeZone
          }}</span>
        </div>
      }
    </div>
  </div>

  <!-- Data source + Update time rows -->
  <div
    class="tw-rounded-xl tw-bg-dt-surface-card tw-overflow-hidden tw-divide-y tw-divide-color-border-subtle"
  >
    <div class="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3">
      <span
        class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-text-color-text-tertiary"
      >
        {{ "dataSource" | i18n }}
      </span>
      <span
        [class]="
          'tw-inline-flex tw-items-center tw-rounded-full tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium ' +
          getBadgeClass(price.source)
        "
      >
        {{ getSourceLabel(price.source) }}
      </span>
    </div>
    @if (price.date.time) {
      <div class="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3">
        <span
          class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-text-color-text-tertiary"
        >
          UPDATE TIME
        </span>
        <span class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
          price.date.time
        }}</span>
      </div>
    }
  </div>

  <!-- Blue info box -->
  <div class="tw-flex tw-gap-3 tw-rounded-xl tw-border tw-border-dt-information-300 tw-p-3">
    <div class="tw-text-dt-information-500 tw-shrink-0 tw-mt-0.5">
      <icon [name]="'info-circle'" [size]="5"></icon>
    </div>
    <div class="tw-flex tw-flex-col tw-gap-1 tw-text-sm tw-text-dt-information-500">
      <p class="tw-m-0">
        <span class="tw-font-semibold">As on Date:</span>
        Choose the date and time this price represents.
      </p>
      <p class="tw-m-0">
        <span class="tw-font-semibold">Update Time:</span>
        Automatically recorded when you save and cannot be edited.
      </p>
    </div>
  </div>

  <!-- Footer buttons -->
  <div class="tw-flex tw-items-center tw-justify-between tw-pt-2 tw-px-2">
    <button
      type="button"
      class="tw-text-sm tw-font-medium tw-text-red-500 hover:tw-text-red-700 tw-bg-transparent tw-border-none tw-cursor-pointer tw-p-0"
      (click)="deletePrice()"
    >
      Delete History
    </button>
    <button
      type="button"
      class="tw-rounded-full tw-shadow-elevation-cta-glow tw-bg-dt-custom-teal-11 tw-px-8 tw-py-2.5 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-90 tw-border-none tw-cursor-pointer"
      (click)="close()"
    >
      {{ "close" | i18n }}
    </button>
  </div>
</div>
